import React from "react"
import { Link } from "gatsby"

import { withArticle } from "./withArticle"
import { Icon } from "../Icon/Icon"
import { ArticleBanner } from "./Banner/ArticleBanner"
import { ArticleBreadcrumb } from "./Breadcrumb/ArticleBreadcrumb"
import { ArticleNavigation } from "./Navigation/ArticleNavigation"
import { ArticleSections } from "./Sections/ArticleSections"
import { StyledContainer } from "../Styled/Container"
import { StyledColumn } from "../Styled/Column"
import { StyledRow } from "../Styled/Row"
import { StyledRule } from "../Styled/Rule"
import { P, Small } from "../Styled/Text"
import { Body, Content, IconWrapper, Next, NextHeading, NextTitle, Title } from "./ArticleStyles"
import { IconCircle } from "../Search/Filter/List/SearchFilterListStyles"

export const Article = withArticle(
  ({ category, content, locales, navigation, next, title, subtitle, nextArticleVisible, handleRegister }): JSX.Element => (
    <>
      <ArticleBanner locales={locales} />
      <Content>
        <StyledContainer width={`xl`}>
          <StyledRow gutter withWrap>
            <StyledColumn gutter width={`md:1/3`}>
              <ArticleBreadcrumb category={category} locales={locales} title={title} />
              <ArticleNavigation category={category} navigation={navigation} />
            </StyledColumn>
            <StyledColumn gutter width={`md:2/3`}>
              <Body>
                <ArticleBreadcrumb category={category} locales={locales} screen={`md`} title={title} />
                <Title withSpacing={`md`} normal colour={`navy`}>
                  {title}
                </Title>
                <P large withSpacing={`md`} colour={`navy`}>
                  {subtitle}
                </P>
                <ArticleSections content={content} />
                {next?.url && (
                  <>
                    <StyledRule />
                    <NextHeading colour={`navy`} italic withSpacing>
                      {locales?.additionalNext}
                    </NextHeading>
                    <Next
                      as={nextArticleVisible ? Link : "div"}
                      title={next?.title}
                      to={nextArticleVisible ? next?.url : ""}
                      onClick={() => (!nextArticleVisible ? handleRegister() : null)}
                    >
                      <StyledRow gutter={`md`} items={nextArticleVisible ? `start` : `center`} justify={`between`}>
                        <StyledColumn gutter={`md`} width={`grow`}>
                          <Small large withSpacing={`sm`}>
                            {locales?.additionalMore}
                          </Small>
                          <NextTitle colour={`white`} large>
                            <strong>{next?.title}</strong>
                          </NextTitle>
                        </StyledColumn>
                        {nextArticleVisible ? (
                          <StyledColumn gutter={`md`} width={`no-shrink`}>
                            <IconWrapper>
                              <Icon name={`arrowRight`} width={26} />
                            </IconWrapper>
                          </StyledColumn>
                        ) : (
                          <StyledColumn gutter={`xs`} width={`no-shrink`}>
                            <IconCircle locked={true}>
                              <Icon name={`lock`} width={14} />
                            </IconCircle>
                          </StyledColumn>
                        )}
                      </StyledRow>
                    </Next>
                  </>
                )}
              </Body>
            </StyledColumn>
          </StyledRow>
        </StyledContainer>
      </Content>
    </>
  )
)
